import React, { useState, useEffect, useContext } from "react";
import "./podcast.css"; // Import the CSS file for styling
import { AiFillStar } from "react-icons/ai";
import { server, truncateText } from "../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import configContext from "../../context/configContext/configContext";

const PodcastList = () => {
  document.title = "Podcasts";
  const [podcasts, setPodcasts] = useState([]);
  const [industrydata, setIndustryData] = useState([]);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  useEffect(() => {
    getData();
    getIndustryData();
  }, []);

  // Get
  const getData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/podcast/getallpodcast", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setPodcasts(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  const getIndustryData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/podcast/getallind_podcast", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setIndustryData(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  // search
  //  const SearchData = (searchValue) => {
  //   server
  //     .get(`/news/searchnews?search=${searchValue}`, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         // "auth-token": user.authToken,
  //       },
  //     })
  //     .then(function (response) {
  //       console.log("api response", response.data);
  //       if (response.status === 200 || response.status === 201) {
  //         setData(response.data);
  //       }
  //     })
  //     .catch(function (error) {
  //       if (error instanceof AxiosError && error.response?.data?.message)
  //         toast.error(error.response.data.message);
  //       else if (error.response?.data?.error) {
  //         toast.error(error.response.data.error);
  //       } else toast.error("Failed to connect to server");
  //     });
  // };

  // const podcasts = [
  //   {
  //     id: 1,
  //     imageUrl:
  //       "https://static.mygov.in/static/s3fs-public/Podcast3_1700469880.jpg",
  //     title: "Startup Hi Kyu? Listen to this #podcast now! Episode: 1",
  //     description: "This is the first episode of our podcast.",
  //     audioUrl: "/podcasts/p1.mp3",
  //   },
  //   {
  //     id: 2,
  //     imageUrl: "https://mygov.in/sites/default/files/master_image/SMPostl.png",
  //     title:
  //       "Dekho Apna Desh Webinar : Journey to Himalaya – Unique experiences with Sh. J.P. Pandey",
  //     description: "This is the first episode of our podcast.",
  //     audioUrl: "/podcasts/p2.mp3",
  //   },
  //   {
  //     id: 3,
  //     imageUrl:
  //       "https://static.mygov.in/static/s3fs-public/Podcast999_1700469880.png",
  //     title:
  //       "Gearing Up for India`s E-Mobility Transition with NITI Aayog`s Randheer Singh Episode: 9",
  //     description: "This is the first episode of our podcast.",
  //     audioUrl: "/podcasts/p3.mp3",
  //   },
  //   {
  //     id: 4,
  //     imageUrl:
  //       "https://static.mygov.in/static/s3fs-public/Podcast8_0_1700469880.png",
  //     title:
  //       "Driving India`s EV Future - Girish Wagh on the Shoonya Podcast Episode: 8",
  //     description: "This is the first episode of our podcast.",
  //     audioUrl: "/podcasts/p4.mp3",
  //   },
  //   {
  //     id: 5,
  //     imageUrl:
  //       "https://static.mygov.in/static/s3fs-public/ShoonyaPodcastEpisode6_1700469880.png",
  //     title:
  //       "Shoonya Podcast: On the Road to E-Mobility with Mr. Gerald Ollivier Episode: 6",
  //     description: "This is the first episode of our podcast.",
  //     audioUrl: "/podcasts/p5.mp3",
  //   },
  //   {
  //     id: 6,
  //     imageUrl:
  //       "https://static.mygov.in/static/s3fs-public/ShoonyaPodcastEpisode5_1700469880.png",
  //     title:
  //       "Shoonya Podcast: Rapidly Electrifying Delhi`s Rides with Mr. Ashish Kundra Episode: 5",
  //     description: "This is the first episode of our podcast.",
  //     audioUrl: "/podcasts/p-6.mp3",
  //   },
  // ];

  const SearchData = (searchValue) => {
    server
      .get(`/podcast/searchallpodcast?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setPodcasts(response.data);
          setIndustryData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // search filter wise
  const FilterData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/podcast/filter?filterByDate=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setPodcasts(response.data);
          setIndustryData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // search filter wise
  const FilterCategoryData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/podcast/searchallpodcast?search=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setPodcasts(response.data);
          setIndustryData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    <div className="container-xl podcast-list" style={{ marginTop: "1rem" }}>
      <h2 className="text-center my-3">Podcasts</h2>
      <div className="row my-3">
        <div className="col-md-4">
          <select
            className="form-control"
            name=""
            id=""
            onChange={(e) => FilterCategoryData(e)} // Pass the event to FilterData
          >
            <option value="industry">Industry</option>
            <option value="institute">Institute</option>
            <option value="university">University</option>
          </select>
        </div>
        <div className="col-md-4 my-1">
          <input
            type="search"
            className="form-control"
            placeholder="Search"
            onChange={(e) => SearchData(e.target.value)}
          />
        </div>
        <div className="col-md-4 my-1">
          <select
            className="form-control"
            onChange={(e) => FilterData(e)} // Pass the event to FilterData
          >
            <option value="2days" defaultValue>
              Newest
            </option>
            <option value="month" defaultValue>
              This Month
            </option>
            <option value="3months">Oldest</option>
          </select>
        </div>
      </div>
      {/* <div className="container-xl my-2">
        <div className="row bg-light text-dark p-4 shadow rounded-2">
          <div className="col-md-4 align-self-center">
            <img
              className="img-fluid"
              src="https://static.mygov.in/static/s3fs-public/Podcast3_1700469880.jpg"
              alt=""
            />
          </div>
          <div className="col-md-7 text-center align-self-center">
            <h3>Startup Hi Kyu? Listen to this #podcast now! Episode: 1</h3>
            <p>Hosted By : Lorem, ipsum.</p>
            <p>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Veniam
              sunt harum ea laborum illum nostrum.
            </p>
            <button className="btn banner p-2 text-white rounded-5">
              Watch Now
            </button>
            <h4>
              Reviews : <AiFillStar />
              <AiFillStar />
              <AiFillStar />
              <AiFillStar />
              <AiFillStar />
            </h4>
          </div>
        </div>
      </div> */}
      <div className="row">
        {podcasts.map((podcast) => (
          <div className="col-md-4 my-2">
            <div className="card" style={{ height: "30rem" }}>
              <div key={podcast.id}>
                <img
                  className="card-img-top"
                  src={podcast.image}
                  height={200}
                />
                <div className="podcast-info p-2 ">
                  <p className="fw-bold">{podcast.title}</p>
                  <p>{truncateText(podcast.description, 20)}</p>
                  <p>Category : {podcast.category}</p>
                  <audio controls>
                    <source src={podcast.media} type="audio/mp4" />
                  </audio>
                </div>
              </div>
            </div>
          </div>
        ))}

        {industrydata
          .filter((item) => item.status === "Post")
          .map((podcast) => {
            return (
              <>
                <div className="col-md-4 my-2">
                  <div className="card" style={{ height: "30rem" }}>
                    <div key={podcast.id}>
                      <img
                        className="card-img-top"
                        src={podcast.media}
                        height={200}
                      />
                      <div className="podcast-info p-2 ">
                        <p className="fw-bold">{podcast.title}</p>
                        <p>{truncateText(podcast.description, 20)}</p>
                        <p>Category : {podcast.category}</p>
                        <audio controls>
                          <source src={podcast.image} type="audio/mp3" />
                        </audio>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
      </div>
    </div>
  );
};

export default PodcastList;
